<template>
  <div class="search-widget">

    <!-- ── Header bar ──────────────────────────────────────── -->
    <div class="search-header mb-3" @click="show = !show" style="cursor: pointer;">
      <div class="d-flex align-items-center" style="gap: 14px;">
        <div class="search-header-icon" :class="{ active: show }">
          <i class="fe" :class="show ? 'fe-x' : 'fe-search'" style="font-size: 14px;"></i>
        </div>
        <div>
          <p class="mb-0 font-weight-bold text-dark" style="font-size: 0.9rem; line-height: 1.2;">Search Enrollees</p>
          <small class="text-muted" style="font-size: 0.75rem;">Find Enrollees</small>
        </div>
      </div>
    </div>

    <!-- ── Search panel ────────────────────────────────────── -->
    <div v-show="show">
      <div class="card shadow-sm search-card mb-4">

        <!-- Card header -->
        <div class="card-header border-0 pt-3 pb-3 px-4" style="background: #f8f9fa;">
          <div class="d-flex align-items-center">
            <span class="badge badge-info mr-2"
              style="border-radius: 50%; width: 26px; height: 26px; line-height: 26px; font-size: 13px;">
              <i class="fe fe-filter" style="font-size: 11px;"></i>
            </span>
            <h6 class="mb-0 font-weight-bold text-dark">Search Filters</h6>
          </div>
        </div>

        <div class="card-body px-4 py-3">

          <!-- Search input -->
          <div class="form-group mb-3">
            <label class="small font-weight-bold text-secondary">Search Key</label>
            <div class="input-group">
              <div class="input-group-prepend">
                <span class="input-group-text bg-white">
                  <i class="fe fe-search text-muted"></i>
                </span>
              </div>
              <input type="text" class="form-control border-left-0" v-model="searchkey" @keyup.enter="searchAll"
                :placeholder="`${agency.firstname} ID, Phone Number, NIN, Name…`" />
              <div class="input-group-append">
                <button class="btn btn-info btn-sm px-3" type="button" :disabled="!searchkey || isLoading"
                  @click="searchAll">
                  <i class="fe fe-search mr-1"></i>
                  {{ isLoading ? 'Searching…' : 'Search' }}
                </button>
              </div>
            </div>
          </div>

          <!-- Enrolled by me checkbox -->
          <div class="mb-4">
            <label class="d-inline-flex align-items-center enrolled-check">
              <input class="mr-2" type="checkbox" v-model="enrolled_by" />
              <span class="small font-weight-bold text-secondary">Enrolled by me only</span>
            </label>
          </div>

          <!-- ── Results ──────────────────────────────────── -->
          <div class="card-header border-0 pt-3 pb-3 px-0 mb-3"
            style="background: transparent; border-top: 1px solid #f1f5f9 !important;">
            <div class="d-flex align-items-center justify-content-between">
              <div class="d-flex align-items-center">
                <i class="fe fe-list text-info mr-2"></i>
                <h6 class="mb-0 font-weight-bold text-dark">Results</h6>
              </div>
              <span class="badge badge-soft-info px-3 py-1" style="border-radius: 20px; font-size: 0.78rem;">
                {{ searched_array.length }} found
              </span>
            </div>
          </div>

          <!-- Result list -->
          <div v-if="searched_array.length" class="result-list">
            <a v-for="(item, index) in searched_array" :key="item.id" :href="`/${item.type}/${item.id}`"
              class="result-item">
              <!-- Avatar placeholder -->
              <div class="result-avatar">
                <i class="fe fe-user"></i>
              </div>

              <div class="flex-grow-1 min-width-0">
                <p class="result-name mb-0">{{ index + 1 }}. {{ item.full_name }}</p>
                <p class="result-meta mb-0">
                  <i class="fe fe-credit-card mr-1" style="font-size: 0.72rem;"></i>
                  {{ item.id_card_number }}
                </p>
              </div>

              <div class="d-flex align-items-center" style="gap: 8px;">
                <span class="result-type-badge">{{ item.type }}</span>
                <i class="fe fe-chevron-right text-muted" style="font-size: 0.85rem;"></i>
              </div>
            </a>
          </div>

          <!-- Empty state -->
          <div v-else-if="hasSearched" class="text-center py-4 text-muted">
            <i class="fe fe-inbox" style="font-size: 2rem; opacity: 0.3;"></i>
            <p class="mt-2 mb-0 small">No records found for your search</p>
          </div>

          <div v-else class="text-center py-3 text-muted">
            <i class="fe fe-search" style="font-size: 1.5rem; opacity: 0.2;"></i>
            <p class="mt-2 mb-0 small">Enter a search term above and press Search</p>
          </div>

        </div>
      </div>
    </div>

    <div class="vld-parent">
      <loading :active.sync="isLoading" loader="dots" :can-cancel="true" :is-full-page="fullPage"></loading>
    </div>
  </div>
</template>

<script>
  import Loading from "vue-loading-overlay";
  import "vue-loading-overlay/dist/vue-loading.css";

  let agency = JSON.parse(localStorage.getItem("agency"));

  export default {
    components: { Loading },
    data() {
      return {
        agency,
        user: null,
        enrolled_by: false,
        searchkey: "",
        show: false,
        hasSearched: false,
        isLoading: false,
        fullPage: true,
        searched_array: [],
      };
    },
    beforeMount() {
      this.user = JSON.parse(localStorage.getItem("user"));
    },
    methods: {
      searchAll() {
        this.isLoading = true;
        this.axios
          .post(`/api/v1/auth/searchenrollees`, {
            agency_id: agency.id,
            request_query: this.searchkey,
            enrolled_by: this.enrolled_by ? this.user.id : null,
          })
          .then((response) => {
            this.searched_array = response.data;
            this.hasSearched = true;
            this.isLoading = false;
            this.$toasted.info("Search complete", { position: "top-center", duration: 2000 });
          })
          .catch((error) => {
            console.error(error);
            this.hasSearched = true;
            this.isLoading = false;
          });
      },
    },
  };
</script>

<style scoped>
  /* ── Header ──────────────────────────────────────────────── */
  .search-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 9px 14px;
    border-radius: 10px;
    background: #ffffff;
    border: 1px solid #e9ecef;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
    color: #1e293b;
  }

  .search-header-icon {
    width: 30px;
    height: 30px;
    background: #e8f7f9;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    color: #17a2b8;
    transition: background 0.15s, color 0.15s;
  }

  .search-header-icon.active {
    background: #17a2b8;
    color: #fff;
  }

  /* ── Card ────────────────────────────────────────────────── */
  .search-card {
    border-radius: 12px;
    border: 1px solid #e9ecef;
  }

  /* ── Input group ─────────────────────────────────────────── */
  .input-group-text {
    font-size: 12px;
    color: #6c757d;
    border-right: none;
  }

  .form-control.border-left-0 {
    border-left: none;
  }

  .form-control:focus {
    border-color: #17a2b8;
    box-shadow: 0 0 0 0.15rem rgba(23, 162, 184, 0.2);
  }

  /* ── Checkbox ────────────────────────────────────────────── */
  .enrolled-check {
    padding: 8px 12px;
    border-radius: 8px;
    background: #f0fafe;
    border: 1px solid #b2e0e8;
    cursor: pointer;
  }

  /* ── Result items ────────────────────────────────────────── */
  .result-list {
    display: flex;
    flex-direction: column;
    gap: 8px;
    max-height: 420px;
    overflow-y: auto;
    padding-right: 4px;
  }

  .result-list::-webkit-scrollbar {
    width: 5px;
  }

  .result-list::-webkit-scrollbar-track {
    background: #f1f5f9;
    border-radius: 4px;
  }

  .result-list::-webkit-scrollbar-thumb {
    background: #b2e0e8;
    border-radius: 4px;
  }

  .result-list::-webkit-scrollbar-thumb:hover {
    background: #17a2b8;
  }

  .result-item {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 12px 14px;
    border: 1px solid #e9ecef;
    border-radius: 10px;
    background: #fff;
    text-decoration: none;
    transition: all 0.15s ease;
  }

  .result-item:hover {
    text-decoration: none;
    border-color: #17a2b8;
    background: #f0fafe;
    box-shadow: 0 4px 12px rgba(23, 162, 184, 0.1);
    transform: translateY(-1px);
  }

  .result-avatar {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    background: #e8f7f9;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #17a2b8;
    font-size: 0.95rem;
    flex-shrink: 0;
  }

  .result-name {
    font-weight: 600;
    color: #1e293b;
    font-size: 0.88rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .result-meta {
    color: #64748b;
    font-size: 0.78rem;
  }

  .result-type-badge {
    padding: 3px 10px;
    border-radius: 20px;
    background: #e8f7f9;
    color: #0c7a8a;
    font-size: 0.72rem;
    font-weight: 700;
    text-transform: capitalize;
    white-space: nowrap;
  }

  .min-width-0 {
    min-width: 0;
  }

  .search-header:hover .search-header-icon:not(.active) {
    background: #d0f0f5;
  }
</style>